const Toggleable = {
  init() {
    if (this.loaded !== true) {
      this.loaded = false
    }
    if (!this.loaded) {
      return this.addWatcher()
    }
  },

  addWatcher() {
    this.loaded = true
    return $(document).on("change", ".toggleable-js", function() {
      return $(this)
        .parent()
        .find(".togglewrap-js")
        .toggleClass("hide")
    })
  },

  initialize() {
    $(document).on("page:load", () => Sprinkles.Toggleable.init())
  }
}

export default Toggleable
